<template>
	<div >
		<div class="rp-messanger-last-order-main rp-home-screen-card"
			:class="loading ? 'loading': 'after-loading'" v-loading="loading">
			<el-collapse-transition>
				<div v-if="!loading">
					<div 
						class="rp-messanger-last-order-header rp-messenger-widget-content-header">
						{{ $t(`orderList.${header}`) }}
					</div>
					<OrderItem
						v-if="orderDetails && orderDetails[0]"
						class="rp-messanger-last-order-main__item"
						:orderData="orderDetails[0]"
						@action="handleOrderAction"
						:actionsList="actionsList || actionsListForOrder"
						:showViewButton="true"
					/>
					<div v-else class="rp-messenger-conversations-list__no-data for-orders">
						<EmptyCart />
						{{$t('homeScreen.noRecentOrders')}}
					</div>
				</div>
			</el-collapse-transition>
		</div>
		<el-collapse-transition>
			<template v-if="!loading">
				<div
					v-if="orderDetails && orderDetails[0]"
					class="rp-messenger-view-all-conversations rp-messenger-view-previous-order">
					<button
						class="btn"
						@click="$emit('openPreviousOrders')"
						>
						{{ $t(`orderList.${footerBtnLabel}`) }}
						<i class="el-icon-right" />
					</button>
				</div>
			</template>
		</el-collapse-transition>
	</div>
</template>

<script>
import EmptyCart from '../../Images/EmptyCart'
export default {
	name: "lastOrder",

	props: {
		orderDetails: {
			type: Array
		},
		header: {
			type: String,
			required: true,
		},
		footerBtnLabel: {
			type: String,
			required: true,
		},
		actionsList: {
			type: Array,
			required: false
		},
		loading: {
			type: Boolean,
			default: false,
		}
	},

	data() {
		return {
			orderAddress: [],
		};
	},

	components: {
		EmptyCart,
	},

	computed: {
		actionsListForOrder() {
			let acitons = [];
			acitons.push(
				{
					buttonLabel: 'help',
					actionName: 'onOrderHelpClick',
				},
				{
					buttonLabel: 'track',
					actionName: 'onOrderTrackUrlClick',
				}
			)
			return  acitons;
		},
	},
  
	methods: {
		handleOrderAction({ actionName, payload }) {			
			if (this.header === 'helpWithThisOrder') {
				const actionName = 'onOrderHelpClick'
				this.$emit(actionName ,payload)
			} else {
				let blockType = "ORDER";
				this.$emit(actionName, payload,blockType)
			}
		}
	}

};
</script>

<style lang="scss" scoped>
.rp-messenger-view-previous-order {
	padding: 20px;
	@include for-size(tablet-landscape-up) {
		margin: 0px;
		padding: 20px 40px;
	}
	@include for-size(desktop-up) {
		margin: 0px;
		padding: 30px 60px;
	}
  .btn {
	color: #333;
	padding: 0px;
	font-size: 14px;
	display: flex;
	align-items: center;
	font-family: $font;
	font-weight: 500;
	.el-icon-right {
		padding-left: 5px;
		font-size: 16px;
		font-weight: 600;
	}
	@include for-size(tablet-landscape-up) { 
		padding: 0px;
		font-size: 16px;
	}
	@include for-size(desktop-up) {
		padding: 0px;
		font-size: 16px;
		.el-icon-right {
			padding-left: 10px;
			font-size: 22px;
		}
	}
  }
}
.rp-messanger-last-order-main {
  min-height: 100px;
  border-bottom: 1px solid #ededed;
  .rp-messanger-last-order-main__item {
    padding: 20px;
	@include for-size(tablet-landscape-up) {
		padding: 40px;
	}
	@include for-size(desktop-up) {
		padding: 30px 60px;
	}
  }

  .rp-messanger-last-order-header {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
    letter-spacing: 0.3px;
    color: #333333;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #e5e5e5;
  }
}
</style>
